import { render, staticRenderFns } from "./detail-delivery.vue?vue&type=template&id=54d4622e&scoped=true"
import script from "./detail-delivery.vue?vue&type=script&lang=js"
export * from "./detail-delivery.vue?vue&type=script&lang=js"
import style0 from "./detail-delivery.vue?vue&type=style&index=0&id=54d4622e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4622e",
  null
  
)

export default component.exports